import { withState } from 'recompose';

export default withState('confirmModal', 'updateConfirmModal', false);
